export default {
  GIVEN_NAME: 'given',
  FAMILY_NAME: 'family'
};